import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GameProvider } from './game/GameContext';
import { I18nProvider, languagePacks } from './i18n';
import { applyTheme, skyTheme } from './config/theme';
import './styles.css';

applyTheme(skyTheme);

async function ensureLatestVersion() {
  if (import.meta.env.DEV) return;
  try {
    const response = await fetch('./version.json', { cache: 'no-cache' });
    const data = await response.json();
    if (data.version && data.version !== __APP_VERSION__) {
      window.location.reload();
    }
  } catch {
    // 版本检查失败时不阻断渲染
  }
}

function mount() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <I18nProvider packs={languagePacks} locale="zh-CN">
        <GameProvider>
          <App />
        </GameProvider>
      </I18nProvider>
    </StrictMode>,
  );
}

ensureLatestVersion().then(mount, mount);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js')
      .then((registration) => {
        // 每小时检查一次是否有新版本
        setInterval(() => registration.update(), 60 * 60 * 1000);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            // 已有旧 SW 在控制页面，新 SW 安装完成，催促它立即接管
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => undefined);

    // 控制页面的 SW 发生变化时自动刷新，确保加载最新 index.html 和新资源
    let reloadPending = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadPending) return;
      reloadPending = true;
      window.location.reload();
    });
  });
}
